
import {useState, useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Main from './pages/main';
import Profile from './pages/cabinet/profile';
import Header from './components/headerauth';
import Footer from './components/footer1';
import PublicStatisticRequests from './pages/statistic_public/ApplicationsPage';
import Cabinet from './pages/cabinet';
import AuthPage from './pages/Auth';
import KindergartenDetails from './pages/kindergartens/detail';
import {KindergartensPage} from './pages/kindergartens/list';
import { AuthProvider, useAuth } from './context/AuthContext';
import CabinetKG from './pages/headerKg';
import { setAuthToken, getUserInfo, setDisabilitiesList } from './services/apiClient';
import { handleLogin } from './services/authService';
import { jwtDecode } from 'jwt-decode';
import PublicStatistics from './pages/PublicStatistic';
import CabinetAdminDOU from './pages/adminDOU';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ExternalEntryPage from './pages/externalPage';

import DocumentDetector from './components/DocumentDetector/DocumentDetector';


const loginInfo = localStorage.getItem('access_token');
const userInfo = getUserInfo();

const authInfo = (token)=>{
  if(!token) return null;
  const decode = jwtDecode(token);
  const { kyivIdUser, privilegedUser } = decode;
  if(kyivIdUser.email == 'igor@kitsoft.kiev.ua') {
      decode['fullusername'] = 'Єфремов І.М.';
  } else {
      decode['fullusername'] = kyivIdUser['email'];
  }

  return decode;
};

const stateauth = authInfo(loginInfo);

// Компонент для инициализации auth
const AuthInitializer = () => {
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      setAuthToken(token);
    }
  }, [token]);

  return null;
};

const rolesValid = {
  dou: ['superadmin', 'admin', 'moderator', 'techassistance', "specialist"],
  moderator: ['moderator'],
  kindergartenhead: ['superadmin','kindergartenHead', 'nurse', 'specialist'],
  nurse: ['kindergartenHead', 'nurse']
}

 const fullWidthRoutes = ['/reqlists', '/kglist', '/publicstatistics', '/profile', '/cabinetdou', '/cabinetheadkg']



function AppContent() {


    const [authState, setAuthState] = useState({
      isAuthenticated: stateauth && stateauth.fullusername || false,
      user: stateauth && stateauth.fullusername || null,
      token: null,
      privilegedUser: userInfo?.privilegedUser || null
    });

    const [showUpperMenu, setShowUpperMenu] = useState(true);

    const fullWidth = fullWidthRoutes.includes(window.location.pathname);

  

    const location = useLocation();



    useEffect(()=>{

      const user_info = localStorage.getItem('user_info');

      if(!user_info) return;

      const { expDate } = JSON.parse(user_info);

      if(!expDate) return;

      if(new Date() > new Date(expDate)) {
        localStorage.clear();
        window.location.href = "/";
      };
 
    },[])

    useEffect(()=>{

      const user_info = getUserInfo();

      if(!user_info) return;

      if(!user_info || !user_info.privilegedUser) return;

      if(!authState 
        || !authState.privilegedUser 
        || !authState.privilegedUser.role 
        || authState.privilegedUser.role !== user_info.privilegedUser.role) {

        setAuthState(Object.assign({}, authState, { privilegedUser: user_info.privilegedUser})) ;
      }

      setShowUpperMenu(["/profile", "/", "/kglist", "/reqlists", "/publicstatistics"].includes(location.pathname) ? true : false );

    },[location]);


    useEffect(()=>{

      setDisabilitiesList();

    },[]);



  const handleAuthSuccess = (tokenData) => {


    const info_token = authInfo(tokenData.token);

    setAuthState({
      isAuthenticated: true,
      user: info_token.fullusername,
      token: tokenData.token,
      privilegedUser: tokenData.privilegedUser
    });


  };

  const handleLogout = () => {

    setAuthState({
      isAuthenticated: false,
      user: null,
      privilegedUser: null
    });

    localStorage.clear();
    //localStorage.removeItem('access_token');
    //localStorage.removeItem('user_info');

    window.location.href = "/";

  };


const role = getUserInfo()?.privilegedUser?.role || null;


 return (

        <>
          <Header 
                state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} 
                user={authState.user}
                onLogout={handleLogout}
                onLogin={handleLogin}
                privelegedlist={authState.privilegedUser && [authState.privilegedUser] || []}
                fullWidth={fullWidth}
                showMenu={showUpperMenu}
                firstpage={["/"].includes(location.pathname)}
          />
          <Routes>
            <Route path="/" element={<Main  state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} token={authState.token} onLogin={handleLogin}/>} />
            <Route path="/profile" element={authState.isAuthenticated ? <Cabinet part="profile" /> : <Navigate to="/" replace />} />
            <Route path="/reqlists" element={<PublicStatisticRequests state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} token={authState.token} />}/>
            <Route path="/cabinet" element={<Cabinet part="default" state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} token={authState.token} />} />
            <Route path="/messages" element={<Cabinet part="messages" state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} token={authState.token}/>} />
            <Route path="/sp_first" element={<AuthPage onAuthSuccess={handleAuthSuccess}/>} />
            <Route path="/object/:id" element={<KindergartenDetails state={authState.isAuthenticated ? "authsuccess" : "unauthorized"} token={authState.token} />}/>
            <Route path="/kglist" element={<KindergartensPage />} />
            <Route path="/cabinetheadkg" element={
              <ProtectedRoute isAuthenticated={rolesValid.kindergartenhead.includes(role)} >
                <CabinetKG part="default"/>
              </ProtectedRoute>} 
              />
            <Route path="/publicstatistics" element={<PublicStatistics />} />
            <Route path="/cabinetdou" element={<ProtectedRoute isAuthenticated={rolesValid.dou.includes(role)} > <CabinetAdminDOU /> </ProtectedRoute>} />
            <Route path="/external_page" element={<ExternalEntryPage />} />
            <Route path="/document-detector" element={<DocumentDetector />} />
          </Routes>
          <Footer fullWidth={fullWidth}/>
          </>
        
  );
  
}

function App(){

  return (
    <Router>
      <AppContent />
    </Router>
  );
  
}

export default App;
